
import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { NavItemProps } from './types';

const NavItem = ({ to, icon: Icon, label, expanded, active }: NavItemProps) => {
  return (
    <li>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <NavLink
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-3 rounded-md",
                  expanded ? "justify-start" : "justify-center",
                  isActive || active
                    ? "bg-sidebar-accent text-accent"
                    : "hover:bg-sidebar-accent/50 text-sidebar-foreground hover:text-accent"
                )
              }
            >
              <Icon className="h-5 w-5" />
              {expanded && <span>{label}</span>}
            </NavLink>
          </TooltipTrigger>
          {!expanded && <TooltipContent side="right">{label}</TooltipContent>}
        </Tooltip>
      </TooltipProvider>
    </li>
  );
};

export default NavItem;
